export const API_ENDPOINTS = {
    eligibilities: '/eligibilities',
}